import { Box, Card, CardHeader } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import React, { useEffect, useState } from 'react';
import { CustomTable } from '../../components/CustomTable';
import { customPalette } from '../../themes/customTheme';

export const GoalsHistory = ({ goals }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const transformedData = Object.entries(goals).flatMap(
      ([date, teamsData]) => {
        const fecha = new Date(date);
        const nombreMes = fecha.toLocaleString('es', {
          month: 'long',
          timeZone: 'UTC',
        });

        const teams = Object.entries(teamsData).flatMap(
          ([teamName, teamEntries]) => {
            if (!Array.isArray(teamEntries)) {
              return [];
            }

            return teamEntries.map(teamEntry => ({
              teamName,
              data: teamEntry,
            }));
          }
        );

        return { date: nombreMes, teams };
      }
    );

    setData(transformedData);
  }, [goals]);

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '24px',
        borderRadius: '20px',
        marginTop: '16px',
      }}
      elevation={0}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingBottom: '10px',
        }}
      >
        <CardHeader
          title="Historial de objetivos"
          sx={{
            padding: '0',
          }}
        />
      </Box>

      <Box sx={{ textAlign: 'start' }}>
        <SimpleTreeView
          sx={{
            border: '1px solid #eee',
            padding: 0,

            li: {
              transition: 'all 0.3s ease',

              '&:not(:first-of-type)': {
                borderTop: '1px solid #e0e0e0',
              },
              '.MuiTreeItem-content:hover, .Mui-selected:hover': {
                backgroundColor: `${customPalette.greyStoke}`,
                borderRadius: '0',
              },
              '.Mui-selected': {
                backgroundColor: `${customPalette.white}`,
                borderRadius: '0',
              },

              '.Mui-selected.Mui-focused, MuiTreeItem-root': {
                backgroundColor: `${customPalette.white}`,
              },

              ul: {
                padding: 0,

                li: {
                  backgroundColor: `${customPalette.white}`,
                  '.MuiTreeItem-content': {
                    paddingLeft: '32px',
                  },

                  '.Mui-expanded, .Mui-expanded.Mui-selected ': {
                    backgroundColor: `${customPalette.background.default}`,
                    borderTop: '1px solid #e0e0e0',
                    transition: 'all 0.3s ease',
                    borderRadius: '0',
                  },
                },
              },
            },
          }}
        >
          {data.map(({ date, teams }, index) => (
            <TreeItem
              key={index}
              itemId={`month-${index}`}
              label={date}
              sx={{
                textTransform: 'capitalize',
              }}
            >
              {teams.map((team, teamIndex) => (
                <TreeItem
                  key={teamIndex}
                  itemId={`team-${index}-${teamIndex}`}
                  label={team.teamName}
                  sx={{
                    backgroundColor: `${customPalette.background.default}`,
                  }}
                >
                  <div>
                    <CustomTable
                      key={`Configuración de objetivo-${teamIndex}`}
                      title="Configuración de objetivo"
                      subtitles={['Vistas', 'Notas', 'Calidad', 'Suscriptos']}
                      values={[
                        Intl.NumberFormat('es-AR', {
                          maximumFractionDigits: 2,
                        }).format(team.data.visits),
                        Intl.NumberFormat('es-AR', {
                          maximumFractionDigits: 2,
                        }).format(team.data.notes),
                        Intl.NumberFormat('es-AR', {
                          maximumFractionDigits: 2,
                        }).format(team.data.rfv),
                        Intl.NumberFormat('es-AR', {
                          maximumFractionDigits: 2,
                        }).format(team.data.subscribers),
                      ]}
                    />

                    <CustomTable
                      key={`Porcentaje del puntaje-${teamIndex}`}
                      title="Porcentaje del puntaje"
                      subtitles={['Vistas', 'Notas', 'Calidad', 'Suscriptos']}
                      values={[
                        team.data.point_visits + '%',
                        team.data.point_notes + '%',
                        team.data.point_rfv + '%',
                        team.data.point_subscribers + '%',
                      ]}
                    />
                  </div>
                </TreeItem>
              ))}
            </TreeItem>
          ))}
        </SimpleTreeView>
      </Box>
    </Card>
  );
};
